<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Discount</span>
      <span v-else>Edit Discount </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="domain_name" :attribute="`fields.domain_name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.domain_name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12">
            <form-group name="value_type" attribute="fields.value_type">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="valueTypes"
                  item-text="name"
                  item-value="name"
                  regular
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.value_type"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12">
            <v-autocomplete
              :loading="loadingData"
              :items="treatments"
              item-text="name"
              item-value="id"
              label="Treatment"
              regular
              :append-icon="form.treatment.id ? 'mdi-close' : ''"
              @click:append="clearData"
              v-model="form.treatment.id"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="form.treatment.id == 6">
            <v-autocomplete
              :loading="loadingData"
              :items="schools"
              item-text="name"
              item-value="id"
              label="School"
              regular
              return-object
              :append-icon="form.school ? 'mdi-close' : ''"
              @click:append="clearSchoolData"
              v-model="form.school"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              :items="employeeTypes"
              item-text="name"
              item-value="id"
              regular
              label="Employee Types"
              return-object
              multiple
              chips
              v-model="form.employee_types_ids"
            ></v-autocomplete>
          </v-col>
          <v-col sm="6" cols="12">
            <section class="increment-label">
              <span>Min Number</span>
              <number-input
                center
                v-model="form.min_no"
                :min="0"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col sm="6" cols="12">
            <section class="increment-label">
              <span>Max Number</span>
              <number-input
                center
                v-model="form.max_no"
                :min="0"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col cols="12">
            <section class="increment-label">
              <span>Value</span>
              <number-input
                center
                v-model="form.value"
                :min="0"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col sm="4" cols="12">
            <section class="transparent-field">
              <v-checkbox
                v-model="form.allow_camp_modify"
                inset
                :true-value="1"
                :false-value="0"
                class="mt-0"
                label="Allow Camp Modify"
                color="primary"
              ></v-checkbox>
            </section>
          </v-col>
          <v-col sm="4" cols="12">
            <section class="transparent-field">
              <v-checkbox
                v-model="form.is_available_for_parents"
                inset
                :true-value="1"
                :false-value="0"
                class="mt-0"
                label="Available For Parent"
                color="primary"
              ></v-checkbox>
            </section>
          </v-col>
          <v-col sm="4" cols="12">
            <section class="transparent-field">
              <v-checkbox
                v-model="form.auto_applied"
                inset
                :true-value="1"
                :false-value="0"
                class="mt-0"
                label="Auto Applied"
                color="primary"
              ></v-checkbox>
            </section>
          </v-col>
          <v-col cols="12" v-if="isEdited">
            <AssignCamps
              :discounts="discounts"
              :form="form"
              :isEdit="isEdited"
              :discoutsItems="discoutsItems"
              @handle_reset_discount="handleResetDiscount"
              @handle_discounts_added="handleDiscountsAdded"
              @camp_name="handleCampName"
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  StoreData,
  ShowData,
  UpdateData,
  IndexDataQuery
} from "@/helpers/apiMethods";
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        name: "",
        value: 0,
        min_no: 0,
        max_no: 0,
        treatment: {
          id: "",
          name: ""
        },
        // school: {
        //   id: "",
        //   name: ""
        // },
        value_type: "",
        domain_name: "",
        employee_types_ids: []
        // auto_applied: 0,
        // is_available_for_parents: 0,
        // allow_camp_modify: 0
      },
      isEdited: false,
      valueTypes: [{ name: "amount" }, { name: "percentage" }],
      majorsIndex: [],
      loadingData: false,
      discounts: {
        id: null,
        value: null,
        name: "",
        value_type: null,
        expiry_date: { date: "" }
      },
      discoutsItems: [],
      employeeTypes: [],
      globalServerErrors: null,
      treatments: [],
      schools: []
    };
  },
  components: {
    AssignCamps: () => import("../components/Assign.vue")
  },
  created() {
    this.editCreateBoolean();
    this.indexDiscountTreatments();
    this.indexEmployeesTypes();
    setTimeout(() => {
      this.discounts.value = this.form.value;
      this.discounts.value_type = this.form.value_type;
    }, 1000);
  },
  methods: {
    indexEmployeesTypes() {
      IndexDataQuery({ reqName: `/employee-types` })
        .then(res => {
          const { data } = res.data;
          this.employeeTypes = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexDiscountTreatments() {
      IndexDataQuery({ reqName: `/discount-treatments` })
        .then(res => {
          const { data } = res.data;
          this.treatments = data;
        })
        .catch(() => {})
        .finally(() => {});
      IndexDataQuery({ reqName: `/schools` })
        .then(res => {
          const { data } = res.data;
          this.schools = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createDiscount();
      } else {
        this.editDiscount();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    handleResetDiscount() {
      this.discounts = {
        discount: null,
        value: this.form.value,
        value_type: this.form.value_type,
        expiry_date: { date: "" }
      };
    },
    handleDiscountsAdded(discountsValues) {
      this.discoutsItems = discountsValues;
    },
    handleCampName(campNaming) {
      // this.discounts.name = campNaming;
      console.log(campNaming, "sdfsdf");
    },
    showData(id) {
      ShowData({
        reqName: `discounts`,
        id: id
      })
        .then(res => {
          const { discount } = res.data;
          this.form = discount;
          this.form.employee_types_ids = discount.employee_types;
          if (discount.treatment == null) {
            this.form.treatment = { id: "" };
          }
        })
        .catch(() => {});
    },
    createDiscount() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (formItem == "employee_types_ids") {
          return;
        } else if (formItem == "treatment" || formItem == "school") {
          formData.append(formItem, this.form[formItem].id);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      this.form.employee_types_ids.forEach(employeeType => {
        formData.append(`employee_types_ids[]`, employeeType["id"]);
      });
      StoreData({
        reqName: `discounts`,
        data: formData
      })
        .then(() => {
          this.$router.push("/discounts");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editDiscount() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      if (this.discounts.expiry_date.date != "") {
        this.discounts.expiry_date = this.$moment(
          this.discounts.expiry_date.date
        ).format(dateFormat);
      }
      Object.keys(this.form).forEach(formItem => {
        if (
          formItem == "camps" ||
          formItem == "employee_types_ids" ||
          formItem == "employee_types" ||
          this.form[formItem] == null
        ) {
          return;
        } else if (formItem == "treatment" || formItem == "school") {
          formData.append(formItem, this.form[formItem].id);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      this.form.employee_types_ids.forEach(employeeType => {
        formData.append(`employee_types_ids[]`, employeeType["id"]);
      });
      if (this.discoutsItems.length == 0) {
        formData.append("camps", []);
      } else {
        this.discoutsItems.forEach((discountItem, index) => {
          Object.keys(discountItem).forEach(discountArea => {
            if (
              discountArea === "name" ||
              discountArea === "type_name" ||
              discountArea === "discount" ||
              discountArea === "start_date" ||
              discountArea === "end_date" ||
              discountArea === "online_payment" ||
              discountArea === "can_register" ||
              discountArea === "allow_camp_modify" ||
              discountArea === "is_available_for_parents" ||
              discountArea === "auto_applied" ||
              discountArea === "location"
            ) {
              return;
            }
            if (discountArea == "expiry_date") {
              if (discountItem[discountArea] !== null) {
                if (discountItem[discountArea].date !== "") {
                  formData.append(
                    `camps[${index}][${discountArea}]`,
                    this.$moment(discountItem[discountArea].date).format(
                      dateFormat
                    )
                  );
                }
              } else {
                formData.append(`camps[${index}][${discountArea}]`, "");
              }
            } else {
              formData.append(
                `camps[${index}][${discountArea}]`,
                discountItem[discountArea]
              );
            }
          });
        });
      }
      formData.append("_method", "put");
      UpdateData({
        reqName: `discounts`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push("/discounts");

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      (this.form = {
        id: "",
        value_type: ""
      }),
        this.$store.dispatch("ClearServerErrors");
    },
    clearData() {
      this.form.treatment.id = "";
    },
    clearSchoolData() {
      this.form.school = {};
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "editDiscount") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      domain_name: {
        maxLength: maxLength(255)
      },
      value: {
        required
      },
      value_type: {
        required
      }
    }
  }
};
</script>
